<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedLocations"
      v-model:search="searchStr"
      multi-select
      searchable
      class="tw-min-w-[250px]"
      :label="meta.filter.quickFilter ? '' : $t('Locations')"
      :list="locations"
      :placeholder="$t('Enter locations (country, city, or state)')"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 5"
      can-deselect
      labels-primary
      allow-new-values
      persist-input-on-select
    >
      <template #select-all-text>
        <WdsText :text="$t('Select all')" />
      </template>
    </WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { computed, ComputedRef, ModelRef, ref } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { ListItem } from '@/components/Workflows/Pages/Workflow/workflow'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedLocations: ModelRef<string[]> = defineModel({
  default: () => [],
})

const searchStr = ref('')

// For now, we'll allow manual entry of locations. In the future, this could be enhanced
// to fetch location data from an API or provide suggestions based on existing data
const locations: ComputedRef<ListItem[]> = computed(() => {
  const result: ListItem[] = []

  // Add search string as an option if it's not empty
  if (searchStr.value && searchStr.value.trim()) {
    const searchValue = searchStr.value.trim()
    const exists = selectedLocations.value.some(loc => loc === searchValue)
    if (!exists) {
      result.push({
        label: searchValue,
        value: searchValue,
      })
    }
  }

  // Add already selected locations
  selectedLocations.value.forEach(location => {
    result.push({
      label: location,
      value: location,
    })
  })

  return result
})
</script>
